import { useContext, useCallback } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';

type DocIdentifier = {
	name: string;
};

export const useAddAbortControllerDocuments = (): (<Doc extends DocIdentifier>(
	documents: Doc[],
) => {
	doc: Doc;
	signal: AbortSignal;
}[]) => {
	const {
		docActions: { uploadDocController },
	} = useContext(ImportStateContext);

	return useCallback(
		<Doc extends DocIdentifier>(documents: Doc[]) => {
			return documents.map((doc) => {
				const controller = new AbortController();
				uploadDocController(doc.name, controller);
				return { doc, signal: controller.signal };
			});
		},
		[uploadDocController],
	);
};
